// Enums for ClinicalSessionProgress - using numeric values to match C# enums
export enum ClinicalSessionStep {
  Person = 1,
  Assessment = 2,
  Results = 3,
  Guidance = 4,
  Completed = 5,
}

export enum ClinicalSessionStatus {
  Draft = 0,
  InProgress = 1,
  Completed = 2,
  Abandoned = 3,
}

// ClinicalSessionProgress - Matches C# Earlymed.DTOs.FlowClinicalSessions.ClinicalSessionProgress
export interface ClinicalSessionProgress {
  currentStep: ClinicalSessionStep;
  totalSteps: number;
  status: ClinicalSessionStatus;
  percentage: number;
}
